var _path, _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccupency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 35.1992V35.3992H1H28.9994H29H29.2V35.1992V14.1128V14.0252L29.1356 13.9658L15.1362 1.05221L15.0007 0.927129L14.865 1.05221L0.864401 13.9658L0.8 14.0252V14.1128V35.1992ZM27.8963 14.644V34.0319H2.10309L2.10246 14.644L15 2.74822L27.8963 14.644Z",
    fill: "#613ED2",
    stroke: "#613ED2",
    strokeWidth: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 22,
    r: 7,
    stroke: "#613ED2",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 22,
    x2: 19,
    y2: 22,
    stroke: "#613ED2",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupency);
export default __webpack_public_path__ + "static/media/occupency.e24c7ef61b289476408843c8d09ad6da.svg";
export { ForwardRef as ReactComponent };